import { Map } from "immutable";
import { CampaignActions } from "./actions";

const initial_state = new Map({
  campaign_utm_code: {},
});

export default function CampaignReducer(state=initial_state, action) {
  switch (action.type) {
    case "persist/REHYDRATE":
      if (action.payload) {
        return new Map(action.payload.CampaignReducer);
      } else {
        return state;
    }
    case CampaignActions.CAMPAIGN_UTM_CODE:
      return state.set("campaign_utm_code", action.campaign_utm_code);
    default:
      return state;
  }
}
